import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProveedorListado from '../../components/Proveedor/proveedoresList';
import { sagaGetProveedores, saveProveedor, sagaEliminarProveedor, sagaGetProveedorByNombre } from '../../reducers/proveedoresReducer/actions';
import { proveedoresDataSelector } from '../../selectors/proveedoresSelector';
import { usuarioSelector } from '../../selectors/sessionSelector';
import * as Notification from '../../components/Common/notification';

class ProveedorContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            nombreProveedor: "",
            proveedores: [],
            allProveedores: [],
            modalData: {
                openModal: false,
                mensaje: "Está por eliminar un proveedor",
                labelModalOk: "Eliminar",
                handleModalOk: () => {},
                handleCloseModal: () => {},
            },
            usuarioCargado: false
        }
        // busco los datos iniciales
        this.busqueda()
    }

    componentDidUpdate = (prevProps) => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({ usuarioCargado: true }, () => {
                if (this.props.usuario.idRol === 4) {
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if (prevProps.proveedores.proveedores !== this.props.proveedores.proveedores) {
            this.setState({ 
                allProveedores: this.props.proveedores.proveedores,
                proveedores: this.props.proveedores.proveedores
            });
        }
    }

    busqueda() {
        this.props.sagaGetProveedores(this.state.nombreProveedor);
        this.props.saveProveedor(undefined);
    }

    handleSearch = (nombreProveedor) => {
        if (!nombreProveedor || nombreProveedor.trim() === "") {
            this.setState({ proveedores: this.state.allProveedores });
        } else {
            const filteredProveedores = this.state.allProveedores.filter(proveedor =>
                proveedor.nombreProveedor.toLowerCase().includes(nombreProveedor.toLowerCase())
            );
            this.setState({ nombreProveedor, proveedores: filteredProveedores });
        }
    }

    setModalData = (proveedor) => {
        this.setState({
            modalData: {
                openModal: true,
                mensaje: `Está por eliminar el proveedor ${proveedor.nombreProveedor}`,
                labelModalOk: "Eliminar",
                handleModalOk: () => {
                    this.props.sagaEliminarProveedor(proveedor.idProveedor);
                    this.setState({ modalData: { openModal: false } });
                },
                handleCloseModal: () => {
                    this.setState({ modalData: { openModal: false } });
                },
            }
        });
    }

    render() {
        return <ProveedorListado 
            proveedores={this.state.proveedores}
            mapToItem={(x) => ({
                nombreProveedor: x.nombreProveedor,
                codigo: x.codigo,
                onClick: x ? () => { 
                    this.props.saveProveedor(x); 
                    this.props.history.push("/Proveedores/Edit/" + x.idProveedor) 
                } : undefined,
                opciones: x ? [
                    { 
                        nombre: "Editar", 
                        handler: () => { 
                            this.props.saveProveedor(x); 
                            this.props.history.push("/Proveedores/Edit/" + x.idProveedor) 
                        } 
                    },
                    { 
                        nombre: "Eliminar", 
                        handler: () => { 
                            this.setModalData(x);
                        }
                    }
                ] : [],
                imagen: (x.imagen) ? x.imagen : require('../../images/default_rubro.png'),
            })}
            handleOnSave={() => {}}
            handleOnSearch={this.handleSearch}
            {...this.state.modalData}
        />
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetProveedores,
        saveProveedor,
        sagaEliminarProveedor,
        sagaGetProveedorByNombre
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        proveedores: proveedoresDataSelector(state),
        usuario: usuarioSelector(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProveedorContainer);